import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { IonAccordionGroup, IonicModule, MenuController } from '@ionic/angular';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { SelectThemeComponent } from '../select-theme/select-theme.component';
import { MenuNavigationService } from 'app/services/menu-navigation.service';
import { SectionButtonsComponent } from '../section-buttons/section-buttons.component';
import { APP_CONSTANTS } from 'app/app.constants';
import { AnalyticsService } from 'app/services/analytics.service';
import { ReferenceComponent } from '../reference/reference.component';
import { PAGES } from 'app/services/analytics-constants';
import { environment } from 'environments/environment';
import { AppConfigProvider } from 'app/app.config';
import { Capacitor } from '@capacitor/core';
import { Router } from '@angular/router';
@Component({
  selector: 'app-side-menu',
  templateUrl: './side-menu.component.html',
  styleUrls: ['./side-menu.component.scss'],
  imports: [IonicModule, CommonModule, TranslateModule, SelectThemeComponent, SectionButtonsComponent, ReferenceComponent],
  standalone: true
})
export class SideMenuComponent {
  @ViewChild('accordId') accordionGroup: IonAccordionGroup;
  @ViewChild('accordSubId') accordionSubGroup: IonAccordionGroup;
  @Output() selectedProductEvent = new EventEmitter<string>();
  @Output() selectedProductSectionEvent = new EventEmitter<string>();
  protected productList;
  protected references = false;
  protected accordionValue = [];
  protected productAccordionValue = [];
  protected isExternal = true;
  protected previousPage = '';

  constructor(
    protected menu: MenuController,
    protected menuNavigationService: MenuNavigationService,
    protected analytics: AnalyticsService,
    private readonly translate: TranslateService,
    public appConfig: AppConfigProvider,
    private readonly router: Router
  ) {
    this.productList = this.menuNavigationService.productsOverview;
    this.isExternal = environment.isExternal;
  }

  protected selectedProduct(event) {
    this.menuNavigationService.title = event.name;
    this.menuNavigationService.selectedProductIndex = event.selectedIndex;
    this.menuNavigationService.selectedProductFromMegaMenu = event.sectionIndex;
    this.menuNavigationService.selectedSectionIndex = 0;
    this.menuNavigationService.selectedSubSectionIndex = 0;
    this.menuNavigationService.subTitle = this.menuNavigationService.productList[event.selectedIndex].sections[0].title;
    this.updatedIndex();
    this.productAccordionValue = [this.productList[event.selectedIndex]?.productName];
    this.menuNavigationService.checkClinicalStudies();
    if (this.previousPage !== APP_CONSTANTS.ROUTE_PATHS.PRODUCT_CONTENT) {
      this.menuNavigationService.navigateByUrl(APP_CONSTANTS.ROUTE_PATHS.PRODUCT_CONTENT);
    }
    this.menuNavigationService.scrollToTop();
  }

  protected selectedProductSection(event) {
    this.accordionValue = [event.sectionName];
    this.menuNavigationService.selectedSectionIndex = event.sectionIndex;
    this.menuNavigationService.selectedSubSectionIndex = 0;
    this.menuNavigationService.subTitle = event.sectionName;
    this.updatedIndex();
    this.analytics.trackAction(this.menuNavigationService.title, this.menuNavigationService.subTitle);
    this.analytics.trackState(`${this.menuNavigationService.title} > ${this.menuNavigationService.subTitle}`);
    this.menuNavigationService.checkClinicalStudies();
    this.previousPage = APP_CONSTANTS.ROUTE_PATHS.PRODUCT_CONTENT;
    this.menuNavigationService.navigateByUrl(APP_CONSTANTS.ROUTE_PATHS.PRODUCT_CONTENT);
    this.menuNavigationService.scrollToTop();
  }

  protected updatedIndex() {
    this.menuNavigationService.updateProductList({
      selectedProductIndex: this.menuNavigationService.selectedProductIndex,
      selectedSectionIndex: this.menuNavigationService.selectedSectionIndex
    });
  }

  protected homeClick() {
    this.resetProductAccordionValue();
    this.resetProductSectionAccordionValue();
    this.menuNavigationService.resetData();
    this.menu.close();
    this.previousPage = '';
    this.menuNavigationService.navigateByUrl(APP_CONSTANTS.ROUTE_PATHS.HOME);
  }

  public openTermsAndPrivacy(segment, title) {
    if (segment === 'privacy' && Capacitor.getPlatform() === 'web') {
      window.open(this.appConfig.privacyPolicyUrl, '_system');
    } else {
      const param = {
        calledFromSettings: true,
        selectedSegment: segment,
      };
      this.previousPage = segment;
      this.menuNavigationService.title = this.translate.instant(title);
      this.menuNavigationService.subTitle = '';
      this.resetProductAccordionValue();
      this.resetProductSectionAccordionValue();
      this.menu.close();
      this.menuNavigationService.navigate(APP_CONSTANTS.ROUTE_PATHS.TERMS_CONDITION, param);
    }
  }

  protected scrollToSection(id, index) {
    this.menuNavigationService.scrollToElement(id);
    this.menuNavigationService.selectedSubSectionIndex = index;
    this.menuNavigationService.checkClinicalStudies();
    this.menu.close();
  }

  protected showReferences(isOpen) {
    this.references = isOpen;
    if (isOpen) {
      this.analytics.trackState(`${PAGES.REFERENCES} > ${this.menuNavigationService.title}`);
    }
  }

  private resetProductAccordionValue() {
    this.productAccordionValue = [];
  }

  private resetProductSectionAccordionValue() {
    this.accordionValue = [];
  }

  public openMenu() {
    if(this.router.url !== '/home' && this.router.url.search('terms') === -1){
      this.productAccordionValue = [this.productList[this.menuNavigationService?.selectedProductIndex]?.productName];
      this.accordionValue = [`${this.productList[this.menuNavigationService.selectedProductIndex]?.productName}${this.menuNavigationService.selectedSectionIndex}`];
    }else{
      this.resetProductAccordionValue();
      this.resetProductSectionAccordionValue();
    }
  }
}
